declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/products.scss';
import '../styles/frames.scss';
import '../styles/pricing.scss';
import '../styles/tables.scss';

import { h, Component } from 'preact';

export default class Onlineleadgen extends Component<any, any> {
  
  constructor() {
    super();
    this.state = {active: false};
    this.toggle = this.toggle.bind(this);
  }
  
  toggle (e) {
    this.setState(state => ({active: !state.active}))
    e.preventDefault();
  }
  
  private showYT (e) {
    e.preventDefault();
    this.props.ytCB('mGJeupFU1-g');
  }
  
  public render (props, state): any {
    
    const callToAction = <p class="center calltoaction"><a href="#" onClick={ this.showYT.bind(this) } class="butt huge">watch demo</a> <a href="./leadgen" target="_blank" class="butt huge">Try it Free</a></p>,
      details = this.state.active ? <section class="animated fadeInUp details">
        <h3>Pricing Details</h3>
        <div class="divTable pricingDetails">
          <div class="divTableBody">
            <div class="divTableRow">
              <div class="divTableCell">&nbsp;</div>
              <div class="divTableCell">FREE</div>
              <div class="divTableCell">Professional</div>
              <div class="divTableCell">Enterprise</div>
            </div>
            <div class="divTableRow">
              <div class="divTableCell">Customizable chat flow</div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
            </div>
            <div class="divTableRow">
              <div class="divTableCell">Backend Analytics Access​</div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
            </div>
            <div class="divTableRow">
              <div class="divTableCell">Unlimited Number of sessions/ month</div>
              <div class="divTableCell">&nbsp;</div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
            </div>
            <div class="divTableRow">
              <div class="divTableCell">CRM Dashboard</div>
              <div class="divTableCell">&nbsp;</div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
            </div>
            <div class="divTableRow">
              <div class="divTableCell">NLU access</div>
              <div class="divTableCell">&nbsp;</div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
            </div>
            <div class="divTableRow">
              <div class="divTableCell">Website Embedding</div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
            </div>
            <div class="divTableRow">
              <div class="divTableCell">API Integration</div>
              <div class="divTableCell">&nbsp;</div>
              <div class="divTableCell">&nbsp;</div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
            </div>
            <div class="divTableRow">
              <div class="divTableCell">Conversation content design</div>
              <div class="divTableCell">&nbsp;</div>
              <div class="divTableCell">&nbsp;</div>
              <div class="divTableCell"><i class="fa fa-check"></i></div>
            </div>
          </div>
        </div>
      </section> : '',
      detailsButt = this.state.active ? <span><i class="fa fa-sort-up"></i> See less details</span> : <span><i class="fa fa-sort-down"></i> See more details</span>;
    
    return <div id="chatbotstudio" class="product">
      <div class="mainWrp">
        <section class="center">
          <h1>Online Lead Generator</h1>
          <h2 class="content">
            Want to increase customer base?<br />You came to the right place!
          </h2>
          { callToAction }
        </section>
      </div>
      <div class="mainWrp frameWrp">
        <div class="col">
          <div class="frame ipad">
            <img class="frameImg" src={STATIC_BASE_URL + 'images/public/frame_ipad.png'} alt="Online Lead Generator" />
            <div class="inframeWrp">
              <img class="inframe" src={ STATIC_BASE_URL + 'images/public/products-leadgen-detail.png'} alt="Online Lead Generator" />
            </div>
          </div>
        </div>
        <div class="col padLeft">
          <h2>Generate more leads for your business with Querlo's AI Solution!</h2>
          <p>
            Our powerful Lead Gen solution can convert higher percentage of your web traffic and produce stronger customer engagement.<br />
            Our solution can help lead customers through virtually every part of the sales funnel.
          </p>
        </div>
        <br style="clear:both" />
      </div>
      <section class="full grey">
        <p>
          The content on your website needs an upgrade. Earlier in the customers journey, the sales team must be able to overcome obstacles that your website and content cannot always meet on their own.
        </p>
        <p>
          Querlo's AI solution can help you bridge this gap. Our lead generator is a winner when it comes to helping in a budget friendly way. You can collect leads at any time, and it will always be available on your website operating 24/7, which eliminates wait time entirely for customers needing assistance. ​
        </p>
        <p>
          Most importantly, our lead generator will create more engaging conversation experiences, handle your visitors' simpler inquiries that allows your support team to focus on more complex issues.
        </p>
      </section>
      <blockquote>
        Marketing Research Report shows that businesses that implement AI see 59% better close rates for sales, 58% increased revenue, 54% more traffic and engagement, and 52% higher conversion.
        <span>DEMANDBASE</span>
      </blockquote>
      
      <section class="features center cols full">
        <div class="mainWrp">
          <h2>Benefits</h2>
          <div class="col">
            <div class="col first">
              <h3><i class="fa fa-swatchbook"></i> Own AI in few minutes</h3>
              <p>
                Starting with our templates, you can create a simple and intelligent chatbot in just a few minutes. No need to feel overwhelmed by the word "AI" - you can play with your own AI anytime.​
              </p>
            </div>
            <div class="col">
              <h3><i class="fa fa-undo-alt"></i> Operates 24 / 7</h3>
              <p>
                The Lead Generator will be on your website 24/7, 365 days and are therefore ready to engage and assist your visitors always, converting them into customers.​
              </p>
            </div>
          </div>
          <div class="col">
            <div class="col">
              <h3><i class="fa fa-grin-hearts"></i> Aggregate User Info</h3>
              <p>
                The AI powered solution will Identify user needs and collect relavent user information based on lead type, and aggregate into CRM dashboard.
              </p>
            </div>
            <div class="col">
              <h3><i class="fa fa-brain"></i> Real-time AI response</h3>
              <p>
                The Lead Generator can answer multiple questions and use data around the question to move leads forward without delay. Fast and efficient responses increase your chances of winnning and retaining customers.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <section class="features full center cols grey">
        <h2>Features</h2>
        <div class="mainWrp">
          <div class="col">
            <div class="col first">
              <h3><i class="fa fa-language"></i> NLU</h3>
              <p>
                The Natural Language Understanding capability can create smooth conversation with powerful logic as keeping the human element in customer service while using AI and machine learning.
              </p>
            </div>
            <div class="col">
              <h3><i class="fa fa-address-book"></i> Integrates with CRM</h3>
              <p>
                The auto generated CRM database from our Lead Generator can integrate with your CRM, complementing valuable customer information.
              </p>
            </div>
          </div>
          <div class="col">
            <div class="col">
              <h3><i class="fa fa-chart-bar"></i> AI identify quality leads</h3>
              <p>
                Lead generator will determine if the visitor is a quality lead based on the conversation flow, user question and interests. Qualified lead can be categorized to boost sales team productivity.
              </p>
            </div>
            <div class="col">
              <h3><i class="fa fa-swatchbook"></i> Highly customizable</h3>
              <p>
                Personalize your lead generator that will reflect your brand voice. You can determine a theme and choose a background, change colors, add images, videos and GIFs, as well edit the tone of the speaker.​
              </p>
            </div>
          </div>
        </div>
      </section>
      {/*<div class="mainWrp">
        <section class="plansWrp">
          <h2>Pricing</h2>
          <ul class="plans">
            <li>
              <div>
                <h3>Starter</h3>
                <p class="price">
                  FREE
                </p>
                <p class="time">usd/month</p>
              </div>
            </li><li class="tall">
            <div>
              <p class="pop">
                Most Popular
              </p>
              <h3>Professional</h3>
              <p class="price">
                $1000
              </p>
              <p class="time">usd/month</p>
            </div>
          </li><li>
            <div>
              <h3>Premium</h3>
              <p class="price">
                $3000
              </p>
              <p class="time">usd/month</p>
            </div>
          </li>
          </ul>
          <button class="moreDetails" onClick={this.toggle}>
            { detailsButt }
          </button>
        
        </section>
        { details }
      </div>*/}
      <section class="full grey">
        { callToAction }
      </section>
    </div>
  }
}


// WEBPACK FOOTER //
// ./ts/Onlineleadgen.tsx